import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { AppConfigService } from './app/main/app-config.service';



platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .then(moduleRef => {
    const appConfig = moduleRef.injector.get(AppConfigService);
    const config = appConfig.getConfig();
    if (config.production) {
      enableProdMode();
      const script = document.createElement('script');
      script.src = 'https://safetechpageencryption.chasepaymentech.com/pie/v1/64100000000181/getkey.js';
      document.head.appendChild(script);
      const script2 = document.createElement('script');
      script2.src = 'https://safetechpageencryption.chasepaymentech.com/pie/v1/encryption.js';
      document.head.appendChild(script2);
    } else{
      const script = document.createElement('script');
      script.src = 'https://safetechpageencryptionvar.chasepaymentech.com/pie/v1/64100000000181/getkey.js'
      document.head.appendChild(script);
      const script2 = document.createElement('script');
      script2.src = 'https://safetechpageencryptionvar.chasepaymentech.com/pie/v1/encryption.js';
      document.head.appendChild(script2);
    }
  })
  .catch(err => console.error(err));
